<div
  *ngIf="control"
  class="wrap"
  [class.invalid]="control.invalid && control.touched"
  (click)="onBodyClick()"
  [class.disabled]="control.disabled"
>
  <div *ngIf="iconName" class="icon">
    <app-svg-icon
      [name]="iconName"
      [color]="
        control.invalid && control.touched
          ? 'color-state-error'
          : 'color-neutral-4'
      "
    ></app-svg-icon>
  </div>
  <div class="content">
    <div class="label">
      {{ label }}
      <span *ngIf="isMarkedAsRequired" class="required-mark">*</span>
    </div>
    <input
      *ngIf="!selectedOption"
      [type]="inputType"
      [placeholder]="placeholder"
      [formControl]="control"
      class="input"
      readonly
    />
    <input
      *ngIf="selectedOption"
      [type]="inputType"
      [placeholder]="placeholder"
      [value]="selectedOption.label"
      class="input input-to-display"
      readonly
    />
    <div class="icon-down">
      <app-svg-icon [name]="'down'"></app-svg-icon>
    </div>
  </div>

  <div *ngIf="shouldShowOptions" class="option-selector">
    <div
      *ngFor="let option of model.options"
      (click)="onOptionSelect(option)"
      class="option"
    >
      {{ option.label }}
    </div>
  </div>
</div>
